type SignKey = '-' | '+';

export function createSignKeyBlocker(blockedSigns: SignKey[]) {
  return (event: KeyboardEvent): void => {
    if (blockedSigns.includes(event.key as SignKey)) {
      event.preventDefault();
    }
  };
}
